import BaseAuthPage from '@common/components/AuthPage/AuthPage'

import { EAuthRoute } from '../../definitions'

import onSuccess from './utils/onSuccess'

/**
 * Bejelentkezést segítő komponens.
 * A request fejlesztői környezetben át lesz irányítva a lokálisan futó corpService-nek.
 * Éles helyzetben az nginx dobja tovább a corpservice.balazs-diak.hu címre.
 */
export default function Auth (): HTMLElement {
  return (
    <BaseAuthPage
      action={ EAuthRoute.Login }
      title="[CORP]"
      onSuccess={ onSuccess }
    />
  )
}
